import React from 'react'

import { BonusSystemState, Bonus } from 'game-ui-types'
import { useCountdownFSBonusStore } from '@stores/countdownFSBonusStore'
import CFSEndButtons from './CFSEndButtons'
import CFSMainButtons from './CFSMainButtons'

interface CFSFooterProps {
    bonus?: Bonus
}

const CFSFooter: React.FC<CFSFooterProps> = ({ bonus }: CFSFooterProps) => {
    const bonusSystemState = useCountdownFSBonusStore((state) => state.bonusSystemState)

    const isInMainState = bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL
    const isInEndState = bonusSystemState === BonusSystemState.END

    if (isInMainState) {
        return <CFSMainButtons bonus={bonus} />
    } else if (isInEndState) {
        return <CFSEndButtons />
    }
}

export default CFSFooter
